import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const formatRupiah = (angka) => {
  if (!angka || angka === 0 || Math.abs(angka) < 0.001)  return "-";
  return new Intl.NumberFormat("id-ID").format(angka);
};

export default function CetakNeraca(data = [], periode = "") {
  const doc = new jsPDF("l", "mm", "a4");
  const pageWidth = doc.internal.pageSize.getWidth();

  const loadImageAsDataURL = (url) => {
  return fetch(url)
    .then((res) => res.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
    );
};
const drawHeader = (logoDataUrl) => {
  const logoX = 10;
  const logoY = 8;
  const logoSize = 18;
  const textX = logoX + logoSize + 3;

  if (logoDataUrl) {
    doc.addImage(logoDataUrl, "PNG", logoX, logoY, logoSize, logoSize);
  }

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text("KPRI SRI REJEKI", textX, 14);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text("Jl. Donomulyo No.164 Kab. Malang", textX, 19);

  const lineY = logoY + logoSize + 3;

  doc.setLineWidth(0.3);
  doc.line(8, lineY, pageWidth - 8, lineY);
};

  // Judul dan Periode
  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.text("LAPORAN NERACA", 148, 40, { align: "center" });

  if (periode) {
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    doc.text(`Periode: ${periode}`, 148, 46, { align: "center" });
  }

  // Warna Tosca
  const toscaDark = [26, 188, 156]; // Tosca tua
  const toscaLight = [163, 228, 215]; // Tosca muda

  // Header tabel dengan warna tosca
  const head = [
    [
      { content: "Kode", rowSpan: 2, styles: { halign: "center", fillColor: toscaDark, textColor: 255, fontStyle: "bold" } },
      { content: "Perkiraan", rowSpan: 2, styles: { halign: "center", fillColor: toscaDark, textColor: 255, fontStyle: "bold" } },
      { content: "Saldo Awal", colSpan: 2, styles: { halign: "center", fillColor: toscaDark, textColor: 255, fontStyle: "bold" } },
      { content: "Mutasi", colSpan: 2, styles: { halign: "center", fillColor: toscaDark, textColor: 255, fontStyle: "bold" } },
      { content: "Rugi Laba", colSpan: 2, styles: { halign: "center", fillColor: toscaDark, textColor: 255, fontStyle: "bold" } },
      { content: "Neraca", colSpan: 2, styles: { halign: "center", fillColor: toscaDark, textColor: 255, fontStyle: "bold" } },
    ],
    [
      // semua Debit / Kredit pakai warna toscaLight sama
      { content: "Debit", styles: { halign: "center", fillColor: toscaDark, textColor: 255 } },
      { content: "Kredit", styles: { halign: "center", fillColor: toscaDark, textColor: 255 } },
      { content: "Debit", styles: { halign: "center", fillColor: toscaDark, textColor: 255 } },
      { content: "Kredit", styles: { halign: "center", fillColor: toscaDark, textColor: 255 } },
      { content: "Debit", styles: { halign: "center", fillColor: toscaDark, textColor: 255 } },
      { content: "Kredit", styles: { halign: "center", fillColor: toscaDark, textColor: 255 } },
      { content: "Debit", styles: { halign: "center", fillColor: toscaDark, textColor: 255 } },
      { content: "Kredit", styles: { halign: "center", fillColor: toscaDark, textColor: 255 } },
    ],
  ];

  let totalAwalDb = 0;
  let totalAwalKd = 0;
  let totalMutasiDb = 0;
  let totalMutasiKd = 0;
  let totalRugiLabaDb = 0;
  let totalRugiLabaKd = 0;
  let totalNeracaDb = 0;
  let totalNeracaKd = 0;
  let totalrugilaba = 0;
  let totalAwalBalance = 0;

  const body = data.map((row) => {
  const awaldb = row.penbia === true || row.penbia === 'true' ? 0 : (row.awaldb || 0);
  const awalkd = row.penbia === true || row.penbia === 'true' ? 0 : (row.awalkd || 0);
  const mutasidb = row.mutasidb || 0;
  const mutasikd = row.mutasikd || 0;

    // Hitung saldo akhir
    let akhirdb = 0;
    let akhirkd = 0;

    if (row.posisi === 'D') {
      const saldo = awaldb - awalkd + mutasidb - mutasikd;
      akhirdb = saldo;
    } else {
      const saldo = awalkd - awaldb + mutasikd - mutasidb;
      akhirkd = saldo;
    }

    let rugilaba_debit = 0;
    let rugilaba_kredit = 0;
    let neraca_debit = 0;
    let neraca_kredit = 0;

    // Jika penbia TRUE: masuk ke Rugi Laba 
    // Jika penbia FALSE: masuk ke Neraca 
    if (row.penbia === true || row.penbia === 'true') {
      rugilaba_debit = akhirdb;
      rugilaba_kredit = akhirkd;
    } else {
      neraca_debit = akhirdb;
      neraca_kredit = akhirkd;
    }

    totalAwalDb += awaldb;
    totalAwalKd += awalkd;
    totalMutasiDb += mutasidb;
    totalMutasiKd += mutasikd;
    totalRugiLabaDb += rugilaba_debit;
    totalRugiLabaKd += rugilaba_kredit;
    totalNeracaDb += neraca_debit;
    totalNeracaKd += neraca_kredit;

    return [
      row.kdperk,
      row.keterangan,
      formatRupiah(awaldb),
      formatRupiah(awalkd),
      formatRupiah(mutasidb),
      formatRupiah(mutasikd),
      formatRupiah(rugilaba_debit),
      formatRupiah(rugilaba_kredit),
      formatRupiah(neraca_debit),
      formatRupiah(neraca_kredit),
    ];
  });

  totalAwalBalance = totalAwalKd - totalAwalDb;  
  totalrugilaba = totalRugiLabaKd - totalRugiLabaDb;

  const kolom = Array(8).fill(formatRupiah(0));

  if (totalAwalBalance < 0) {
    kolom[1] = formatRupiah(totalAwalBalance);
    totalAwalKd += totalAwalBalance;
  }
  else{
    kolom[0] = formatRupiah(Math.abs(totalAwalBalance));
    totalAwalDb += Math.abs(totalAwalBalance);
  }

  const totalNeracaRL = totalAwalBalance - totalrugilaba;
  
  if (totalrugilaba > 0) {
    kolom[4] = formatRupiah(totalrugilaba); // kolom sebelum terakhir
    totalRugiLabaDb += totalrugilaba;
  } else
  {    
    kolom[5] = formatRupiah(Math.abs(totalrugilaba));
    totalRugiLabaKd += Math.abs(totalrugilaba);
  }  
  if (totalNeracaRL > 0 ){
    totalNeracaDb += totalNeracaRL;
    kolom[6] = formatRupiah(totalNeracaRL);     
  }
  else
  {
    kolom[7] = formatRupiah(Math.abs(totalNeracaRL));
    totalNeracaKd += Math.abs(totalNeracaRL);       
  }  

  const labarugi = [
    { content: "Laba Rugi", colSpan: 2, styles: { fontStyle: "bold", halign: "center" } },
    ...kolom
  ]

  body.push(labarugi);

  const totals = [
    { content: "Total", colSpan: 2, styles: { fontStyle: "bold", halign: "center" } },
    formatRupiah(totalAwalDb),
    formatRupiah(totalAwalKd),
    formatRupiah(totalMutasiDb),
    formatRupiah(totalMutasiKd),
    formatRupiah(totalRugiLabaDb),
    formatRupiah(totalRugiLabaKd),
    formatRupiah(totalNeracaDb),
    formatRupiah(totalNeracaKd)
  ];

 const renderTable = () => {
  autoTable(doc, {
    startY: 55,
    head: head,
    body: body,
    theme: "grid",
    styles: {
      fontSize: 9,
      cellPadding: 2,
      halign: "right",
      valign: "middle",
      overflow: "linebreak",
      cellWidth: "wrap",
      minCellHeight: 6,
    },
    alternateRowStyles: {
      fillColor: [230, 247, 243],
    },
    columnStyles: {
      0: { halign: "center", cellWidth: 20 },
      1: { halign: "left", cellWidth: 40 },
    },
    headStyles: { fontStyle: "bold" },
    foot: [totals],
    footStyles: {
      fontStyle: "normal",
      fillColor: toscaLight,
      textColor: [0, 0, 0],
    },
    showFoot: "lastPage",
  });

  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl, "_blank");
};

const customLogoUrl = "/koperasihitamputih.png";

loadImageAsDataURL(customLogoUrl)
  .then((logoDataUrl) => {
    drawHeader(logoDataUrl);
    renderTable();
  })
  .catch(() => {
    drawHeader();
    renderTable();
  });
}